import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import Chip from '@mui/material/Chip';
import React from 'react';
import type { TemplateVarsDataItem } from 'types/templates/templates-menu';
import useLocalization from 'hooks/useLocalization';
import { getHeaderMediaFieldLabel } from './template-media-field-label';

interface TemplateParamMediaBadgeProps {
  param: Pick<TemplateVarsDataItem, 'name' | 'label'>;
  compact?: boolean;
}

const TemplateParamMediaBadge: React.FC<TemplateParamMediaBadgeProps> = ({ param, compact = false }) => {
  const { currentLocale } = useLocalization();
  const mediaLoc = currentLocale.templatesMenu.singleTemplate.media;
  const tableLoc = currentLocale.settingsPopup.massMessagingTasks.taskUsersTable.templatePreview;

  if (param.name !== 'data') return null;

  const label = getHeaderMediaFieldLabel(param, mediaLoc) || tableLoc.fileParamFallback;

  const icon =
    param.label === 'image' ? (
      <ImageOutlinedIcon />
    ) : param.label === 'video' ? (
      <VideocamOutlinedIcon />
    ) : param.label === 'document' ? (
      <DescriptionOutlinedIcon />
    ) : (
      <AttachFileOutlinedIcon />
    );

  return (
    <Chip
      size="small"
      icon={icon}
      label={label}
      color="info"
      variant="outlined"
      sx={{
        maxWidth: '100%',
        height: compact ? 24 : 28,
        '& .MuiChip-label': {
          px: 0.75,
          fontSize: compact ? '0.7rem' : '0.75rem',
        },
        '& .MuiChip-icon': {
          fontSize: compact ? '0.95rem' : '1rem',
        },
      }}
    />
  );
};

export default TemplateParamMediaBadge;
